import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../context";
import { COLLECTIONS, t } from "../content";
import { Instagram } from "lucide-react";

export const Footer = () => {
  const { lang } = useLang();
  const legal = [
    { key: "privacy", fr: "Politique de confidentialité", en: "Privacy policy" },
    { key: "terms", fr: "Conditions d'utilisation", en: "Terms of use" },
    { key: "returns", fr: "Politique de retour", en: "Return policy" },
    { key: "shipping", fr: "Politique d'expédition", en: "Shipping policy" },
  ];
  return (
    <footer className="bg-[#1A1A1A] text-[#F9F8F6] mt-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20 grid grid-cols-2 md:grid-cols-4 gap-12">
        <div className="col-span-2 md:col-span-1">
          <div className="serif text-2xl tracking-[0.25em]">CLASSONE VINTAGE</div>
          <p className="mt-4 text-sm text-[#F9F8F6]/60 max-w-xs leading-relaxed">
            {lang === "fr" ? "Streetwear vintage premium. Pièces rares, tons neutres, sélectionnées au Canada." : "Premium vintage streetwear. Rare pieces, neutral tones, curated in Canada."}
          </p>
        </div>
        <div>
          <h4 className="text-xs uppercase tracking-widest text-[#F9F8F6]/50 mb-5">{t.nav.collections[lang]}</h4>
          <ul className="space-y-3 text-sm">
            {COLLECTIONS.map((c) => (
              <li key={c.slug}><Link to={`/shop?c=${c.slug}`} className="text-[#F9F8F6]/80 hover:text-[#F9F8F6] transition-colors">{c[lang]}</Link></li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="text-xs uppercase tracking-widest text-[#F9F8F6]/50 mb-5">{lang === "fr" ? "Aide" : "Help"}</h4>
          <ul className="space-y-3 text-sm">
            <li><Link to="/faq" className="text-[#F9F8F6]/80 hover:text-[#F9F8F6]">FAQ</Link></li>
            <li><Link to="/contact" className="text-[#F9F8F6]/80 hover:text-[#F9F8F6]">{t.nav.contact[lang]}</Link></li>
            {legal.map((l) => (
              <li key={l.key}><Link to={`/policy/${l.key}`} className="text-[#F9F8F6]/80 hover:text-[#F9F8F6]">{l[lang]}</Link></li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="text-xs uppercase tracking-widest text-[#F9F8F6]/50 mb-5">{lang === "fr" ? "Réseaux" : "Social"}</h4>
          <a href="https://instagram.com" target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 text-sm text-[#F9F8F6]/80 hover:text-[#F9F8F6]">
            <Instagram size={16} strokeWidth={1.5} /> Instagram
          </a>
        </div>
      </div>
      <div className="border-t border-[#F9F8F6]/10 pt-10">
        <div className="serif text-center text-[14vw] leading-none tracking-tight text-[#F9F8F6]/10 select-none pointer-events-none">
          ClassOne Vintage
        </div>
      </div>
      <div className="border-t border-[#F9F8F6]/10 py-6 text-center text-xs text-[#F9F8F6]/40 tracking-wide">
        © {new Date().getFullYear()} ClassOne Vintage — {lang === "fr" ? "Tous droits réservés." : "All rights reserved."}
      </div>
    </footer>
  );
};
